import { render, staticRenderFns } from "./dtp-query-page.vue?vue&type=template&id=485492e5&scoped=true"
import script from "./dtp-query-page.vue?vue&type=script&lang=js"
export * from "./dtp-query-page.vue?vue&type=script&lang=js"
import style0 from "./dtp-query-page.vue?vue&type=style&index=0&id=485492e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485492e5",
  null
  
)

export default component.exports